import {
  Form,
  Select,
  Row,
  Col,
  Button,
  Radio,
  Modal,
  AutoComplete,
  Input,
  Spin,
  DatePicker,
  message
} from "antd";
import React, { Component } from "react";
import moment from "moment";
import _ from "lodash";
import NumericInput from "../NumericInput";
import {
  showSuccessNotification,
  showErrorNotification,
  strings
} from "../../helpers";
import { updatePromoCode } from "../../services";

import { addPromoCode } from "../../services";

const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const { Option } = Select;

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth();
const toMonth = new Date(currentYear, currentMonth);

class PromoCodeView extends Component {
  /**
   * @function handleInviteEmployer
   * @description it will get the form data and hit the api
   */
  handleAddPromo = e => {
    const { form } = this.props;

    e.preventDefault();

    form.validateFieldsAndScroll((err, value) => {
      if (!err) {
        const {
          toggleAddModal,
          toggleIsProcessing,
          refreshPromoCodeList,
          stopIsProcessing
        } = this.props;
        toggleAddModal();
        toggleIsProcessing();
        let requestObj = {
          promo_code_name: value.name,
          single_use: value.singleUse,

          expiry: moment(value.date).format("YYYY-MM-DD")
        };

        if (value.discountUnit === "₹") {
          requestObj.discount_amount = parseFloat(value.discount);
        } else if (value.discountUnit === "%") {
          requestObj.discount_percentage = parseFloat(value.discount);
        }

        addPromoCode(requestObj)
          .then(response => {
            form.resetFields();

            if (response.data.success) {
              refreshPromoCodeList();
              const successMsg = "Promo code added successfully.";
              showSuccessNotification(successMsg);
            } else {
              const { errors } = response.data;

              let error = errors;
              if (Array.isArray(errors)) {
                error = errors[0];
              }
              showErrorNotification(error.title);
            }
            stopIsProcessing();
          })
          .catch(() => {
            toggleIsProcessing();
          });
      }
    });
  };

  /**
   * @function handleUpdatePromo
   * @description it will get the form data and hit the api
   */
  handleUpdatePromo = e => {
    const { form, selectedRecord } = this.props;

    e.preventDefault();

    form.validateFieldsAndScroll((err, value) => {
      if (!err) {
        const {
          toggleAddModal,
          toggleIsProcessing,
          refreshPromoCodeList,
          stopIsProcessing
        } = this.props;
        toggleAddModal();
        toggleIsProcessing();
        let requestObj = {
          promo_code_name: value.name,
          single_use: value.singleUse,

          expiry: moment(value.date).format("YYYY-MM-DD")
        };

        if (value.discountUnit === "₹") {
          requestObj.discount_amount = parseFloat(value.discount);
        } else if (value.discountUnit === "%") {
          requestObj.discount_percentage = parseFloat(value.discount);
        }

        updatePromoCode(requestObj, selectedRecord.id)
          .then(response => {
            form.resetFields();

            if (response.data.success) {
              refreshPromoCodeList();
              const successMsg = "Promo code updated successfully.";
              showSuccessNotification(successMsg);
            } else {
              const { errors } = response.data;

              let error = errors;
              if (Array.isArray(errors)) {
                error = errors[0];
              }
              showErrorNotification(error.title);
            }
            stopIsProcessing();
          })
          .catch(() => {
            toggleIsProcessing();
          });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      showAddModal,
      handleSubmit,
      toggleAddModal,
      processing,
      selectedRecord
    } = this.props;
    let edit = true;
    let discountUnit = "₹";
    let discount = "";
    let name = "";
    let singleUse = "";
    let date = "";
    if (_.isEmpty(selectedRecord)) {
      edit = false;
    }

    if (edit) {
      if (selectedRecord.discount_percentage) {
        discountUnit = "%";
        discount = selectedRecord.discount_percentage;
      }
      if (selectedRecord.discount_amount) {
        discountUnit = "₹";
        discount = selectedRecord.discount_amount;
      }
      if (selectedRecord.promo_code_name) {
        name = selectedRecord.promo_code_name;
      }

      singleUse = selectedRecord.single_use;

      if (selectedRecord.expiry) {
        date = moment(selectedRecord.expiry);
      }
    }

    return (
      <Modal
        maskClosable={false}
        destroyOnClose
        title={"Add Promo Code"}
        visible={showAddModal}
        onCancel={toggleAddModal}
        footer={null}
        className="kc-modal-medium no-footer"
      >
        <Form
          onSubmit={event =>
            edit ? this.handleUpdatePromo(event) : this.handleAddPromo(event)
          }
          layout="vertical"
        >
          <Row type="flex" gutter={8}>
            <Col span={6}>
              <FormItem label={"Discount"}>
                {getFieldDecorator("discount", {
                  initialValue: discount,
                  rules: [
                    {
                      required: true,
                      message: `${"Discount is required"}`
                    }
                  ]
                })(
                  <NumericInput className="ant-input" placeholder="Discount" />
                )}
              </FormItem>
            </Col>
            <Col span={4}>
              <FormItem label="&nbsp;">
                {getFieldDecorator("discountUnit", {
                  initialValue: discountUnit
                })(
                  <Select>
                    <Option value="₹">₹</Option>
                    <Option value="%">%</Option>
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={12} className="appt_date_col">
              <FormItem label={"Expire By"} className="appointment_date">
                {getFieldDecorator("date", {
                  initialValue: date,
                  rules: [
                    {
                      required: true,
                      message: `${"Expire by date is required"}`
                    }
                  ]
                })(
                  <DatePicker
                    type="date"
                    disabledDate={this.props.disabledDate}
                  />
                )}
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" gutter={8}>
            <Col span={12} className="appt_date_col">
              <FormItem label={"Promo code name"}>
                {getFieldDecorator("name", {
                  initialValue: name,
                  rules: [
                    {
                      required: true,
                      message: `${"Promo code name required"}`
                    }
                  ]
                })(<Input placeholder={"name"} name="name" />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label={"Single Use"}>
                {getFieldDecorator("singleUse", {
                  initialValue: singleUse,
                  rules: [
                    {
                      required: true,
                      message: "Single use required"
                    }
                  ]
                })(
                  <RadioGroup>
                    <Radio style={{ fontWeight: 300 }} value={true}>
                      Yes
                    </Radio>
                    <Radio style={{ fontWeight: 300 }} value={false}>
                      No
                    </Radio>
                  </RadioGroup>
                )}
              </FormItem>
            </Col>
          </Row>

          <Row className="modal-footer-row">
            <Col span={24}>
              <Button type="primary" htmlType="submit" size="small">
                {edit ? "Update" : "Add"}
              </Button>
              <Button
                size="small"
                className="ml-8"
                onClick={() => {
                  toggleAddModal();
                }}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

const PromoCodeForm = Form.create()(PromoCodeView);
export default PromoCodeForm;
